<template>

    <section class="section">
        <section class="container is-max-widescreen is-max-desktop">
            <h1 class="title has-text-centered">
                Ventilation des marges
            </h1>


            <div class="columns">

                <div class="column is-half">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Marge totale CEN NA
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ this.addSpace(this.roundTwoDigits(grandTotal, 2)) }} €</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="column is-half">
                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Marge restante disponible CEN NA
                            </p>
                        </header>
                        <div class="card-content">
                            <div class="content">
                                <span class="title h1">{{ this.addSpace(this.roundTwoDigits(fullCredit, 2)) }} €</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <hr>

        <div class="columns">
            <div class="column is-4">

                <b-field grouped>

                    <b-field label="Sélectionner une antenne ou service">
                        <b-select
                            placeholder="Sélectionner"
                            v-model="selectedGroup"
                            @input="refreshTable()">
                            <option
                                v-for="option in groups"
                                :value="option"
                                :key="option"
                            >
                                {{ option }}
                            </option>
                        </b-select>
                    </b-field>

                    <b-field>
                        <b-field label="Synthèse régionnale">
                            <b-button
                                type="is-primary"
                                @click="globalView()"
                                :disabled="selectedGroup === null">
                                Voir
                            </b-button>
                        </b-field>
                    </b-field>
                </b-field>
            </div>
            <div class="column is-3">
                <b-field label="Marge générée par l'antenne - service">
                    <b-tag class="is-info" size="is-large">
                        {{ this.addSpace(this.roundTwoDigits(margeByService[selectedGroup], 2)) }} €
                    </b-tag>
                </b-field>
            </div>
            <div class="column is-3">
                <b-field label="Marge disponible pour ventilation">


                    <b-tag :class="
                                [
                                    {'is-danger': (credit - (margeByService[selectedGroup] * 0.2)) < 0},
                                    {'is-warning': (credit - (margeByService[selectedGroup] * 0.2)) <= 1000},
                                    {'is-success': (credit - (margeByService[selectedGroup] * 0.2)) > 1000},
                                ]
                                "
                           size="is-large">
                        {{ this.addSpace(this.roundTwoDigits(credit - (margeByService[selectedGroup] * 0.2), 2)) }} €
                    </b-tag>
                    <span v-if="selectedGroup !== null">

            <b-tag
                size="is-large">
              {{
                    this.addSpace(this.roundTwoDigits(((margeByService[selectedGroup] - credit) * 100 / margeByService[selectedGroup]), 2))
                }} %
            </b-tag>
            <b-tooltip
                label="Marge disponible en euro pour ventilation = 80% de la marge générée par l'antenne/service. Les 20% restants sont réservés pour le financement des frais de missions."
                multilined>
              <b-icon
                  type="is-info"
                  icon="info-circle"
                  size="is-small">
              </b-icon>
            </b-tooltip>

          </span>

                </b-field>


            </div>

            <div class="column is-2">
                <b-field label="Enregistrer la ventilation">
                    <b-button
                        type="is-primary"
                        @click="postUpdateVentilation()"
                        :disabled="userGroup !== selectedGroup">
                        Enregistrer
                    </b-button>
                </b-field>
            </div>


        </div>

        <b-table
            :data="displayData"
            bordered
            striped>

            <b-table-column
                field="name"
                label="Personnel"
                v-slot="props">
        <span class="pointer" @click="getDetail(props.row.name)">
          {{ props.row.name }}
        </span>
            </b-table-column>

            <b-table-column field="fonction" label="Fonction" v-slot="props">
                {{ props.row.fonction }}
            </b-table-column>

            <b-table-column field="margeallouable" label="Objectif à financer (jours)" centered v-slot="props">
                {{ selectedGroup ? props.row.margeallouable[selectedGroup] : SyntheseAFinancer(props.row.name) }}
            </b-table-column>

            <b-table-column field="" label="Déjà financé sur projet, hors projet fonctionnement (jours)" centered
                            v-slot="props">
                {{ selectedGroup ? props.row.byservice[selectedGroup] : SyntheseSurProjet(props.row.name) }}
            </b-table-column>

            <b-table-column field="" label="Ventilation sur marge (jours)" centered v-slot="props">
                <b-field>
                    <b-input
                        v-model="ventilationmarges[props.row.name][selectedGroup]"
                        v-if="selectedGroup"
                        @input="ventilationmarges[props.row.name][selectedGroup] = parseFloat(ventilationmarges[props.row.name][selectedGroup])"
                        type="number"
                        step="0.5"
                        :disabled="userGroup !== selectedGroup">
                    </b-input>
                    <div
                        v-if="!selectedGroup">
                        {{ SyntheseSurMarge(props.row.name) }}
                    </div>

                </b-field>

            </b-table-column>

            <b-table-column
                field=""
                label="Marge restante à financer (jours)"
                centered
                v-slot="props">
                <div
                    v-if="selectedGroup">
                    {{
                        props.row.margeallouable[selectedGroup] - ventilationmarges[props.row.name][selectedGroup] - (props.row.byservice[selectedGroup] > 0 ?
                            props.row.byservice[selectedGroup]
                            :
                            0)
                    }}
                </div>
                <div
                    v-if="!selectedGroup">
                    {{
                        SyntheseAFinancer(props.row.name) - (SyntheseSurMarge(props.row.name))
                    }}
                </div>
            </b-table-column>

            <template #empty>
                <div class="has-text-centered">No records</div>
            </template>

        </b-table>

        <!-- Modal détail charge salariés -->
        <b-modal :active.sync="isSalarieModalActive"
                 has-modal-card
                 full-screen>
            <ChargeSalarie
                :detailSalarie="detailSalarie">
            </ChargeSalarie>
        </b-modal>

    </section>

</template>

<script>
import ChargeSalarie from "./ChargeSalarie";

export default {
    name: "Marges",
    components: {ChargeSalarie},
    mounted() {
        this.getTotal();
        this.getSalariesSurMarge();
    },
    computed: {
        credit() {
            let credit = 0;
            let consomme = 0;
            if (typeof this.ventilationmarges === 'object' && this.ventilationmarges !== null) {

                for (const [key, value] of Object.entries(this.ventilationmarges)) {

                    let daycost = this.data.filter(item => item.name === key).map(filteredObj => filteredObj.daycost);
                    if (daycost.length === 1) {
                        if (!isNaN(value[this.selectedGroup])) {
                            consomme += daycost[0] * value[this.selectedGroup]
                        }
                    }
                }
            }
            credit = this.margeByService[this.selectedGroup] - consomme;
            return credit;
        },
        fullCredit() {
            let credit = 0;
            let consomme = 0;
            if (typeof this.ventilationmarges === 'object' && this.ventilationmarges !== null) {
                for (const [key, value] of Object.entries(this.ventilationmarges)) {
                    // console.log(key) : Nom
                    // console.log(value) : Object "Service" : jours affecté
                    let daycost = this.data.filter(item => item.name === key).map(filteredObj => filteredObj.daycost);
                    if (daycost.length === 1) {
                        for (const [k, v] of Object.entries(value)) {
                            if (!isNaN(v)) {
                                consomme += daycost[0] * v
                            } else {
                                console.log(k)
                            }

                        }
                    }
                }
            }
            credit = this.grandTotal - consomme;
            return credit;
        },
    },
    methods: {
        globalView() {
            this.selectedGroup = null
            this.displayData = this.data;
        },
        SyntheseAFinancer(name) {
            let o = this.data.filter(item => item.name === name)
            // console.log(o[0].margeallouable)
            return this.sumObj(o[0].margeallouable);
        },
        SyntheseSurProjet(name) {
            let o = this.data.filter(item => item.name === name)
            // console.log('data : ', this.data)
            return this.sumObj(o[0].byservice);
        },
        SyntheseSurMarge(name) {
            // console.log(name)
            let o = this.ventilationmarges[name]
            // console.log(this.ventilationmarges[name])
            // console.log(o)
            return this.sumObj(o);
        },
        getTotal() {
            this.$axios.get(`marges`)
                .then(function (res) {
                    // console.log(res.data.margeGrandTotal)
                    this.grandTotal = res.data.margeGrandTotal;
                    this.groups = res.data.groups
                    this.margeByService = res.data.margeByService;
                    this.userGroup = res.data.userGroup;
                }.bind(this))
        },
        refreshTable() {
            this.displayData = this.data.filter(item => item.margeallouable[this.selectedGroup] !== undefined && item.margeallouable[this.selectedGroup] !== null)
        },
        getSalariesSurMarge() {
            const loadingComponent = this.$buefy.loading.open({
                container: null
            })
            // TODO : optimiser cette fonction
            this.$axios.get(`ref/salariessurmarge`)
                .then(function (res) {
                    this.data = res.data.surmarge;
                    this.displayData = res.data.surmarge;
                    // console.log(res.data.ventilation)
                    this.ventilationmarges = res.data.ventilation;
                    // console.log(this.ventilationmarges)
                    // console.log(this.data)
                    loadingComponent.close()
                }.bind(this))


        },
        postUpdateVentilation() {
            if (this.ventilationmarges !== null) {
                this.$axios.post('UpdateVentilation', {
                    doc: this.ventilationmarges
                }, {})
                    .then((res) => {
                        if (res.data.status === "KO") {
                            this.$buefy.dialog.alert({
                                title: `Une erreur est survenue`,
                                type: "is-danger",
                                confirmText: "Revenir sur ma saisie",
                                hasIcon: true,
                                message: `Ok`,
                            });
                        } else {
                            this.$buefy.dialog.alert({
                                title: `Ok`,
                                type: "is-success",
                                confirmText: "Ok",
                                hasIcon: true,
                                message: `Ok`,
                            });
                        }
                    })
                    .catch(function (error) {
                        //handle error
                        console.log(error);
                    });
            }
        },
        getDetail(s) {
            this.$axios.get(`charge?salarie=${s}`)
                .then(function (response) {
                    this.detailSalarie = response.data;
                    this.isSalarieModalActive = true;
                }.bind(this))
                .catch(error => console.log(error));
        },
    },
    data() {
        return {
            userGroup: null,
            grandTotal: null,
            groups: [],
            selectedGroup: null,
            data: [],
            displayData: [],
            margeByService: {},
            ventilationmarges: null,
            // Modal détail salariés
            detailSalarie: [],
            isSalarieModalActive: false,
        }
    }
}
</script>

<style scoped>
.pointer {
    cursor: pointer;
}
</style>
